<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Tgqv61/tc-custom/9781615950553.jpg?1731166618674" alt="This image is the cover for the book Anglo-Irish Murders, Robert Amiss/Baroness Jack Troutbeck Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Anglo-Irish Murders, Robert Amiss/Baroness Jack Troutbeck Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <p>Foolishly, the British and Irish governments have chosen the tactless and impatient Baroness Troutbeck to chair a conference on Anglo-Irish cultural sensitivities. She instantly press-gangs Robert Amiss, her young friend and reluctant accomplice, into becoming conference organizer.</p><p>It is a conference to remember in more ways than one. When a delegate plummets off the battlements, no one, not even the authorities, can decide whether it was by accident or design. The next death poses the same problem and causes warring factions to accuse each other of murder even as the politicians are busily trying to brush everything under the carpet in the name of peace.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ruth Dudley Edwards
      </h2>
      
      <p class="authorDescription body article"><P>Ruth Dudley Edwards is a historian and journalist as well as a mystery writer. The targets of her satirical crime novels include the gentlemen's clubs, Cambridge University, the House of Lords, journalism and literary prizes. The British Crime Writers' Association short-listed Corridors of Death for the John Creasy Award for best first novel, and Clubbed to Death and Ten Lords A-Leaping for their Last Laugh Award. She won the CrimeFest Last Laugh Award for Murdering Americans in 2008 and in 2010 the CWA Non-fiction Gold Dagger for Aftermath: the Omagh bombings and the families' pursuit of justice. Her twelfth mystery, Killing the Emperors, is a black comedy about conceptual art.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Poisoned Pen Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?18776742